import Median from 'median-js-bridge';
import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const TABS = {
  '/': 0,
  '/user/favorite-events': 1,
  '/user/orders': 3,
  '/user/orders/[orderId]': 3,
  '/user/profile': 4,
};

const useMedian = () => {
  const [isMedian, setIsMedian] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setIsMedian(navigator.userAgent.indexOf('median') > -1);
    Median.onReady(() => {
      setIsMedian(Median.isNativeApp());
    });
  }, [isMedian, setIsMedian]);

  const selectSearchTab = () => Median.tabNavigation.selectTab(2);

  const detectTab = useCallback(() => {
    Median.tabNavigation.deselect();
    const tabIndex = TABS[router.pathname as keyof typeof TABS];
    if (tabIndex !== undefined) {
      Median.tabNavigation.selectTab(tabIndex);
    }
  }, [router.pathname]);

  useEffect(() => {
    if (isMedian) {
      detectTab();
    }
  }, [detectTab, isMedian, router]);

  return {
    isMedian,
    detectTab,
    selectSearchTab,
  };
};

export default useMedian;
